
import { Input, Component } from '@angular/core';

@Component({
    selector: 'gaweb-summary',
    templateUrl: 'summary.component.html'
})
export class SummaryComponent {
    private _subDescriptions: string[];
    @Input()
    set subDescriptions(str: string[]) {
        this._subDescriptions = str;
    }
    get subDescriptions(): string[] {
        return this._subDescriptions;
    }
    private _displayDescription: string[];
    @Input()
    set displayDescription(str: string[]) {
        this._displayDescription = str;
    }
    get displayDescription(): string[] {
        return this._displayDescription;
    }
}



// WEBPACK FOOTER //
// ./src/app/travel-products/product-passenger-details/summary/summary.component.ts